import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StyleSheet, View } from 'react-native';
import { CommonStyles } from '../../styles';
import BaseText from '../BaseText';
import TripSearchWidget from '../TripSearchWidget/TripSearchWidget';
import { setSearchInput, tripSearch } from '../../store/actions/search';
import { validateTripSearch } from '../../utils/search.utils';
import { openAlert } from '../../store/actions/alert';
import { Screens } from '../../constants/ScreenNames';

const JoinTrip = () => {
  const dispatch = useDispatch();
  const searchTripLoading = useSelector((s) => s.search.tripResultsLoading);
  const onSearchHandler = async (searchInput, searchInputState) => {
    const validationResult = validateTripSearch(searchInput);
    if (validationResult.isFailed) {
      dispatch(openAlert({ message: validationResult.msg }));
    } else {
      await dispatch(setSearchInput(searchInput, searchInputState));
      dispatch(tripSearch(Screens.TripHub));
    }
  };

  return (
    <View style={styles.container}>
      <BaseText style={[CommonStyles.px3, CommonStyles.py4, CommonStyles.h4]}>
        That time of year folks, annual sales meet and greet. Make sure to get there by 10am on June
        20.
      </BaseText>
      <TripSearchWidget onSearch={onSearchHandler} loading={searchTripLoading}></TripSearchWidget>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
  },
});

export default JoinTrip;
